import { ALLOWED_FEATURE_KEYS } from './common-constants';

/* ----------- Exhibitor - Sponsor common redirection calls starts ---------- */
/**
 * These 2 are allowed sources for exhibitor and sponsor (common details).
 * Excluding exhibitor and sponsor from here for the logical flexibilities in the component.
 */
export const ALLOWED_EXHIBITOR_SOURCE = [
  // 'exhibitor',
  'notesToExh',
  'scanToExh',
  'globalToExh',
  'globalToNotesToExh',
  'sessionToExh',
  'communityToExh'
];
export const ALLOWED_SPONSOR_SOURCE = [
  // 'sponsor',
  'notesToSpn',
  'scanToSpn',
  'globalToSpn',
  'globalToNotesToSpn',
  'sessionToSpn',
  'communityToSpn'
];
export const ALLOWED_EXH_SPN_FOR_NOTES = [
  'notesToExh',
  'notesToSpn',
  'globalToNotesToExh',
  'globalToNotesToSpn'
];
/* ------------ Exhibitor - Sponsor common redirection calls ends ----------- */

export const ALLOWED_ATTENDEE_PROFILE_SOURCE = [
  ALLOWED_FEATURE_KEYS.attendee,
  ALLOWED_FEATURE_KEYS.exhibitor,
  ALLOWED_FEATURE_KEYS.sponsor,
  ALLOWED_FEATURE_KEYS.message, // m
  ALLOWED_FEATURE_KEYS.community, // m
  ALLOWED_FEATURE_KEYS.gamification, // m
  ALLOWED_FEATURE_KEYS.notes, // m
  ALLOWED_FEATURE_KEYS.notifications, // m
  ALLOWED_FEATURE_KEYS.schedule, // m
  ALLOWED_FEATURE_KEYS.social, // m
  'profile-image', // userProfilePic common component
  'chatthread',
  'booth-personnel'
];

export const ALLOWED_SCHEDULEDATE_APICALL_SOURCE = {
  session: 'session',
  maps: 'map-details',
  bookmark: 'bookmark',
  ads: 'advertisement'
};

export const ALLOWED_VERTICAL_POPUP_SOURCES = {
  types: {
    socialCard: 'social-card',
    communityIntro: 'community_introduce',
    sessionLiveQA: 'session_liveqa',
    sessionRating: 'session_rating',
    addPoll: 'add-poll',
    sessionEdit: 'session_edit'
  },
  sources: [
    'social-card',
    'community_introduce',
    'session_liveqa',
    'session_rating',
    'add-poll',
    'session_edit'
  ]
};

export const ALLOWED_SURVEY_FORM_SOURCES = {
  survey: 'survey',
  trivia: 'trivia',
  mandatory: 'mandatory',
  schedule: ALLOWED_FEATURE_KEYS.schedule
};
